import { queryOpenCourseList } from '@api/homepage';
export default {
    state: {
        subject_id: 0,
        grade: 0,
        page: 1,
        openListTotal: 0,
        openList: []
    },
    mutations: {
        SET_OPEN_LIST(state, data) {
            state.openList = data;
        },
        SET_SUBJECT(state, data) {
            state.subject_id = data;
        },
        SET_GRADE(state, data) {
            state.grade = data;
        },
        SET_PAGE(state, data) {
            state.page = data;
        },
        SET_TOTAL(state, data) {
            state.openListTotal = data;
        }
    },
    actions: {
        async getOpenList({ commit, state }) {
            const { subject_id, grade, page } = state;
            const { code, data, count } = await queryOpenCourseList({ subject_id, grade, page });
            if (code === 0) {
                commit('SET_TOTAL', count);
                commit('SET_OPEN_LIST', data);
            }
        }
    }
};
